import Component from '../core/Component'
import { load } from 'recaptcha-v3'
import { RECAPTCHA_KEY } from '../core/config'


export default class Form extends Component {
    constructor($element) {
        super($element)

        this.recaptcha = null
        this.shouldSubmit = false
    }

    prepare() {
        load(RECAPTCHA_KEY, {
            autoHideBadge: true
        })
        .then((recaptcha) => {
            this.recaptcha = recaptcha
            if (this.shouldSubmit) {
                this.submit()
            }
        })

        this.element.addEventListener('submit', this.handleSubmit)
    }

    handleSubmit = event => {
        event.preventDefault()
        this.submit()
    }

    submit() {

        const isValid = Nette.validateForm(this.element)

        if (!isValid) {
            this.shouldSubmit = false
            return
        }

        this.element.classList.add('is-loading')

        if (!this.recaptcha) {
            this.shouldSubmit = true
            return
        }

        this.recaptcha.execute(RECAPTCHA_KEY, {
            action: 'submit'
        })
        .then(token => {
            const data = new FormData(this.element)
            data.append('token', token)

            $.nette.ajax({
                url: this.element.action,
                type: this.element.method || 'POST',
                data: data,
                contentType: false,
                processData: false,
                complete: () => {
                    this.element.classList.remove('is-loading')
                }
            })
        })
    }
}


// WEBPACK FOOTER //
// ./components/Form.js